import { createSelectors } from "@/redux/helpers/selector";

import { MODULE } from "./constants";

export const [getAlerts] = createSelectors(MODULE, ["alerts"]);
